import React from 'react'
import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'

import { GridCellParams } from '@mui/x-data-grid-pro'

import { Icon, Text } from '@mxenabled/mxui'

import { useGlobalCopyStore } from '../../../../../common'

const CategoryCell = (params: GridCellParams) => {
  const { transactions: copy } = useGlobalCopyStore()
  const [isHover, setIsHover] = React.useState(false)

  return (
    <Stack
      alignItems="center"
      direction="row"
      gap={8}
      height="100%"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      width="100%"
    >
      {params.row.has_been_split && <Icon name="call_split" size={16} />}
      <Text tabIndex={params.tabIndex} variant="body2">
        {params.row.has_been_split ? copy.split_transaction_category_label : params.row.category}
      </Text>
      {!params.row.has_been_split && isHover && (
        <Icon name="edit" sx={{ color: 'action.active' }} />
      )}
    </Stack>
  )
}

export default observer(CategoryCell)
